import React from "react";

import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";

const ConfirmModal = (props) => {
  const {
    title = "Confirm delete action?",
    show = true,
    isConfirming,
    onConfirm,
    confirmText = "Delete",
    confirmButtonProps = {},
    onCancel,
    cancelText = "Cancel",
    cancelButtonProps = {},
    children = () => {},
    showCloseIcon = false,
    showContentDivider = false,
    style,
  } = props;

  return (
    <ModalWrapper
      title={title}
      show={show}
      showCloseIcon={showCloseIcon}
      maxWidth="xs"
      onClose={onCancel}
      style={style}
      showContentDivider={showContentDivider}
      actionButtons={[
        {
          label: cancelText,
          variant: cancelButtonProps.variant || "outlined",
          className: cancelButtonProps.className,
          style: cancelButtonProps.style,
          color: cancelButtonProps.color,
          onClick: onCancel,
          disabled: isConfirming,
        },
        {
          label: confirmText,
          variant: confirmButtonProps.variant || "contained",
          className: confirmButtonProps.className,
          style: confirmButtonProps.style,
          color: confirmButtonProps.color,
          onClick: onConfirm,
          isLoading: isConfirming,
          disabled: isConfirming || confirmButtonProps.disabled,
        },
      ]}
    >
      {children}
    </ModalWrapper>
  );
};

export default ConfirmModal;
